import React, { Component } from "react";
import { Container, Form, Row, Col, Button, Modal } from "react-bootstrap";
import { submitFormData } from "../utilities/formUtilities";

class CareersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideModalFormClass: "show",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "hide",
      displayHowDidYouHearAboutUsRequired: "hide",
    };
    this.submitForm = this.submitForm.bind(this);
    this.successfulSubmitForm = this.successfulSubmitForm.bind(this);
    this.resetAndHideModal = this.resetAndHideModal.bind(this);
    this.resetModal = this.resetModal.bind(this);
    this.errorSubmitForm = this.errorSubmitForm.bind(this);
    this.resetHowDidYouHearAboutUsError = this.resetHowDidYouHearAboutUsError.bind(this);
  }

  submitForm = (e) => {
    e.preventDefault();
    // console.log("submitting form");


    let whereDidYouHear = e.target.elements.whereDidYouHear.value;
    
    let formDataValid = true;

    let displayErrors = {};

    if (whereDidYouHear === "DEFAULT") {
      formDataValid = false;
      displayErrors["displayHowDidYouHearAboutUsRequired"] = "show"; 
    }

    if (formDataValid) {

      let firstName = e.target.elements.firstName.value;
      let lastName = e.target.elements.lastName.value;
      let links = e.target.elements.links.value;
      let email = e.target.elements.email.value;
      let reason = e.target.elements.reason.value;


      let submitData = {
        firstName: firstName,
        lastName: lastName,
        links: links,
        email: email,
        reason: reason,
        whereDidYouHear: whereDidYouHear
      };

      // console.log(submitData);

      /*
      https://formcarry.com/s/0p9CKKf9uTv2
      bld_ai_events_careers@bld.ai
      */

      submitFormData(
        "https://formcarry.com/s/0p9CKKf9uTv2",
        submitData,
        this.successfulSubmitForm,
        this.errorSubmitForm,
        this.errorSubmitForm
      );
    } else {
      this.setState(displayErrors);
    }
  }

  successfulSubmitForm = () => {
    this.setState({ 
      hideModalFormClass: "hide",
      displaySuccessSubmitClass: "show",
      displayErrorSubmitClass: "hide",
    });
  }

  errorSubmitForm = () => {
    this.setState({ 
      hideModalFormClass: "hide",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "show",
    });
  }

  resetModal = () => {
    let careersForm = document.getElementById("careersForm");

    careersForm.reset();
    this.setState({ 
      hideModalFormClass: "show",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "hide",
      displayHowDidYouHearAboutUsRequired: "hide",
    });
  }

  resetAndHideModal = () => {
    this.resetModal();
    this.props.closeModal();
  }

  resetHowDidYouHearAboutUsError = () => {
    this.setState({
      displayHowDidYouHearAboutUsRequired: "hide", 
    });
  }

  render() {
    return(
      <Modal show={this.props.modalOpen} onHide={this.resetAndHideModal} centered>
        <Modal.Header className="header-center" closeButton>
          <span className="modal-header-text">Job Inquiries</span>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <div className="contact-modal-description mb-5">
              <p className="text-center">
                Our highest priority is to satisfy our clients through early and continuous delivery of human-centered products. Do you love making things people want? We'd love to hear from you.
              </p>
            </div>
            <section className={"contact contactFormContainer " + this.state.hideModalFormClass}>
              <form acceptCharset="UTF-8" className="contact-form ajax" onSubmit={this.submitForm} id="careersForm">
                <Row>
                  <Col sm="12" md="6">
                    <Form.Group>
                      <Form.Label>First name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="firstName" />
                    </Form.Group>
                  </Col>
                  <Col sm="12" md="6">
                    <Form.Group>
                      <Form.Label>Last name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="lastName" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Links (e.g. resume, Github, CodeForces, Dribbble, Kaggle, Blog)<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="links" />
                    </Form.Group>
                  </Col>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Email<span className="required">*</span></Form.Label>
                      <Form.Control required type="email" name="email" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>How did you hear about us?<span className="required">*</span></Form.Label>
                      <p className={"howDidYouHearAboutUsRequired " + this.state.displayHowDidYouHearAboutUsRequired}>Please select one of the options</p>
                      <Form.Control as="select" required name="whereDidYouHear" defaultValue={'DEFAULT'} onChange={this.resetHowDidYouHearAboutUsError}>
                        <option value="DEFAULT" disabled>Please select</option>
                        <option value='Press/News'>Press/News</option>
                        <option value="Search Engine">Search Engine</option>
                        <option value="Event/Tradeshow">Event/Tradeshow</option>
                        <option value="Word of Mouth">Word of Mouth</option>
                        <option value="Referral">Referral</option>
                        <option value="Other">Other</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Why do you want to work at bld.ai?<span className="required">*</span></Form.Label>
                      <Form.Control as="textarea" rows="3" required name="reason"/>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <input type="hidden" name="_gotcha" />
                    <Button className="btn-submit hs-button" type="submit">Submit</Button>
                    <Button className="hs-button ml-2 btn-secondary" onClick={this.resetAndHideModal}>Close</Button>
                  </Col>
                </Row>
              </form>
            </section>
            <section className={"contact contactFormContainer confirmationMessage " + this.state.displaySuccessSubmitClass}>
              <p>Form submitted successfully</p>
              <Button className="btn-submit hs-button" onClick={this.resetModal}>
                Send another careers query
              </Button>
            </section>
            <section className={"contact contactFormContainer confirmationMessage " + this.state.displayErrorSubmitClass}>
              <p>There was an error with the submission. Please try again</p>
              <Button className="btn-submit hs-button" onClick={this.resetModal}>
                Send another careers query
              </Button>
            </section>
          </Container>
        </Modal.Body>
      </Modal>
    );
  }
}

export default (CareersModal);